// eslint-disable-next-line @typescript-eslint/no-var-requires
const tailwindThemeTokens = require('./figmaTokens.json');

const themeColors = () => {
  return tailwindThemeTokens['colors'];
};
// NOTE:We can use this to responsive font size depend on vw
// font-size:clamp(minvalue, viewport, maxvalue)
// ex font-size: clamp (24px,10vw,42px)
const themeFontSize = () => {
  return tailwindThemeTokens['fontSize'];
};

const themeFontWeight = () => {
  return tailwindThemeTokens['fontWeight'];
};
const themeLineHeight = () => {
  return tailwindThemeTokens['lineHeight'];
};
const themeLetterSpacing = () => {
  return tailwindThemeTokens['letterSpacing'];
};

const themeBoxShadow = () => {
  return tailwindThemeTokens['boxShadow'];
};

const themeBorderWidth = () => {
  return tailwindThemeTokens['borderWidth'];
};
const themeBorderRadius = () => {
  return tailwindThemeTokens['borderRadius'];
};

const themeSpacing = () => {
  return tailwindThemeTokens['spacing'];
};

const themeOpacity = () => {
  return tailwindThemeTokens['opacity'];
};
const themeScreens = () => {
  return tailwindThemeTokens['screens'];
};

const fromPxToRem = (value) => {
  return `${Number(value) / 16}rem`;
};

module.exports = {
  themeColors,
  themeFontSize,
  themeFontWeight,
  themeLineHeight,
  themeBoxShadow,
  themeBorderWidth,
  themeBorderRadius,
  themeLetterSpacing,
  themeSpacing,
  themeOpacity,
  themeScreens,
  fromPxToRem,
};
